import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/ContentListBlock/contentListBlock.container"
    ).then((module) => ({ default: module.ContentListBlock }))
);
